/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { LinkedInConnectionRequestTaskCreatePriority } from './linkedInConnectionRequestTaskCreatePriority';
import type { LinkedInConnectionRequestTaskCreateTaskNoteDoc } from './linkedInConnectionRequestTaskCreateTaskNoteDoc';

export interface LinkedInConnectionRequestTaskCreate {
  job_id: string;
  candidate_id: string;
  assignee_user_id: string;
  due_at?: string | null;
  priority?: LinkedInConnectionRequestTaskCreatePriority;
  title?: string | null;
  type: 'linkedin_connection_request';
  linkedin_account_id?: string | null;
  target_linkedin_url?: string | null;
  /** @maxLength 300 */
  invitation_note?: string;
  task_note_doc?: LinkedInConnectionRequestTaskCreateTaskNoteDoc;
}
